import { render } from "./InterViewDetail.vue?vue&type=template&id=e84f67b4&scoped=true"
import script from "./InterViewDetail.vue?vue&type=script&lang=js"
export * from "./InterViewDetail.vue?vue&type=script&lang=js"

import "./InterViewDetail.vue?vue&type=style&index=0&id=e84f67b4&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e84f67b4"]])

export default __exports__